import React from 'react'

import { useTranslation } from 'react-i18next'

import team from '../../../assets/team.webp'
import { SectionText } from '../../../components/SectionText'

interface TeamProps {
    className?: string
}

export const Team: React.FC<TeamProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div
            id="team"
            className={`${className} flex justify-between min-h-[500px] w-full text-white
            sm:flex-col sm:h-auto sm:min-h-[700px]
        `}>
            <div className="w-2/3 h-full sm:w-full">
                <img src={team} alt="team" className="h-full w-full object-cover" />
            </div>
            <div className="bg-primary-blue w-1/3 h-auto min-h-[300px] flex items-center justify-center sm:w-full">
                <SectionText
                    className="max-w-[280px]"
                    title={t('landingPage.team.title')}
                    hrLineColor="bg-primary-green"
                    discoverMore={true}
                    discoverMoreLink="/team">
                    <div className="justify-center">{t('landingPage.team.description')}</div>
                </SectionText>
            </div>
        </div>
    )
}
